import { ActionButton } from '@formstack/phoenix/components/Button';
import { Modal, ModalContent, ModalFooter, ModalHeader } from '@formstack/phoenix/components/Modal';
import { ActionVariants } from '@formstack/phoenix/components/actionVariants/constants';

import { IConfirmationDialog } from '@/common/components/ConfirmationDialog/interface';
import { useResource } from '@/common/resources';

export const ConfirmationDialog = (props: IConfirmationDialog) => {
  const {
    id = 'confirmation',
    onCancel,
    onConfirm,
    open,
    heading,
    message,
    cancelLabel,
    confirmLabel,
    ariaHeadingLabel,
    confirmationVariant = ActionVariants.deleteVariant,
    confirmOnly = false,
    confirmDisabled = false,
    isLoading = false,
  } = props;
  const resource = useResource((resource) => resource);

  return (
    <Modal
      id={id}
      data-test={id}
      ariaLabel={ariaHeadingLabel || resource.confirm}
      closeAction={onCancel}
      open={open}
    >
      <ModalHeader id={`${id}-header`} withCloseButton={true}>
        {heading}
      </ModalHeader>

      <ModalContent>{message}</ModalContent>

      <ModalFooter>
        {confirmOnly ? undefined : (
          <ActionButton
            dataTest={`${id}-cancel-modal`}
            action={onCancel}
            buttonText={cancelLabel || resource.cancel}
            noBackground={true}
            variant={ActionVariants.edit}
            disabled={isLoading}
          />
        )}

        <ActionButton
          dataTest={`${id}-confirm-modal`}
          action={onConfirm}
          buttonText={confirmLabel || resource.confirm}
          variant={confirmationVariant}
          disabled={confirmDisabled || isLoading}
        />
      </ModalFooter>
    </Modal>
  );
};
